<template>
    <div class="vx-toast" :class="iconsClass == '' ? 'vx-toast-none-icon' : ''">
            <div v-if="iconsClass" :class="iconsClass"></div>
            <p class="vx-toast-content" v-html="mes"></p>
        </div>
</template>

<script>
    export default {
        props: {
            mes: String,
            icon: String,
            timeout: Number,
            callback: Function
        },
        computed: {
            iconsClass() {
                let _icon = '';
                if (this.icon === 'success' || this.icon === 'error') {
                    _icon = 'vx-toast-' + this.icon + '-icon';
                }
                return _icon;
            }
        }
    }
</script>
<style lang="less">
@import "../dialog.less";

</style>